<!--
 * @Author: chenz
 * @Date: 2024-07-23 10:33:24
 * @LastEditors: chenz
 * @LastEditTime: 2024-08-02 14:32:17
 * @Description: Do not edit
 * @FilePath: \project\src\views\footer\index.vue
-->
<template>
  <div class="footer" :class="className">
    <a href="https://beian.miit.gov.cn">鲁ICP备2025188245号-1</a>
    <p>© 2025 山东省二级建造师继续教育平台. All rights reserved.</p>
    <p>济南鲁凝教育咨询服务有限公司</p>
    <p>地址：山东省济南市历下区仁恒世纪花园2号楼101</p>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data(){
    return {
      className:''
    }
  },
  mounted(){
    this.$nextTick(()=>{
      setTimeout(()=>{this.isAbsolute()},500)
    })
  },
  methods:{
    isAbsolute(){
      const parentHeight = document.querySelector('#app').offsetHeight
      const viewportHeight = window.innerHeight;
      console.log(parentHeight);
      if(viewportHeight > parentHeight){
        this.className = 'absolute'
      }else{
        this.className = ''
      }
      
    }
  }
}
</script>


<style scoped lang="scss">
a {
  color: #999;
  font-size: 12px;
}

a:hover {
  color: #999;
}
.footer {
  // width: 100%;
  // position: fixed;
  // bottom: 0;
  // left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
  padding: 20px 0;
  background-color: #f5f5f5;
  border-top: 1px solid #eaeaea;
  cursor: default;
  p {
    padding: 0;
    margin: 4px 0;
    font-size: 12px;
    color: #999;
  }
}
.absolute{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
